import { render, staticRenderFns } from "./SalesDocuments.vue?vue&type=template&id=6b9dfbd2&scoped=true&"
import script from "./SalesDocuments.vue?vue&type=script&lang=js&"
export * from "./SalesDocuments.vue?vue&type=script&lang=js&"
import style0 from "./SalesDocuments.vue?vue&type=style&index=0&id=6b9dfbd2&prod&lang=css&"
import style1 from "./SalesDocuments.vue?vue&type=style&index=1&id=6b9dfbd2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9dfbd2",
  null
  
)

export default component.exports